module.exports = __webpack_public_path__ + "media/images/favicons/master_image-d4cb1f930bbaa407bd9b0b24c9725e4f.svg";